import { render, staticRenderFns } from "./HealthScoreDataProtection.vue?vue&type=template&id=3c73d8a8"
import script from "./HealthScoreDataProtection.vue?vue&type=script&lang=js"
export * from "./HealthScoreDataProtection.vue?vue&type=script&lang=js"
import style0 from "./HealthScoreDataProtection.vue?vue&type=style&index=0&id=3c73d8a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports